export const configDiffCheckerUrl = {
    live: 'https://service.mobilemoxie.com/php-diff/runDiffer.php',
    staging: 'https://servicedev.mobilemoxie.com/php-diff/runDiffer.php',
    test1: 'https://servicedev.mobilemoxie.com/php-diff/runDiffer.php',
    test2: 'https://servicedev.mobilemoxie.com/php-diff/runDiffer.php',
    test3: 'https://servicedev.mobilemoxie.com/php-diff/runDiffer.php',
    test4: 'https://servicedev.mobilemoxie.com/php-diff/runDiffer.php',
    test5: 'https://servicedev.mobilemoxie.com/php-diff/runDiffer.php',
    test6: 'https://servicedev.mobilemoxie.com/php-diff/runDiffer.php',
    test7: 'https://servicedev.mobilemoxie.com/php-diff/runDiffer.php',
    test8: 'https://servicedev.mobilemoxie.com/php-diff/runDiffer.php',
    test9: 'https://servicedev.mobilemoxie.com/php-diff/runDiffer.php',
    test10: 'https://servicedev.mobilemoxie.com/php-diff/runDiffer.php',
    test11: 'https://servicedev.mobilemoxie.com/php-diff/runDiffer.php',
    test12: 'https://servicedev.mobilemoxie.com/php-diff/runDiffer.php',
    test13: 'https://servicedev.mobilemoxie.com/php-diff/runDiffer.php',
    test14: 'https://servicedev.mobilemoxie.com/php-diff/runDiffer.php',
    test15: 'https://servicedev.mobilemoxie.com/php-diff/runDiffer.php',
}
export const configBaseUrl = {
    live: 'https://mobilemoxie.com/',
    staging: 'https://staging.mobilemoxie.com/',
    test1: 'https://test1.devv2.mobilemoxie.com/',
    test2: 'https://test2.devv2.mobilemoxie.com/',
    test3: 'https://test3.devv2.mobilemoxie.com/',
    test4: 'https://test4.devv2.mobilemoxie.com/',
    test5: 'https://test5.devv2.mobilemoxie.com/',
    test6: 'https://test6.devv2.mobilemoxie.com/',
    test7: 'https://test7.devv2.mobilemoxie.com/',
    test8: 'https://test8.devv2.mobilemoxie.com/',
    test9: 'https://test9.devv2.mobilemoxie.com/',
    test10: 'https://test10.devv2.mobilemoxie.com/',
    test11: 'https://test11.devv2.mobilemoxie.com/',
    test12: 'https://test12.devv2.mobilemoxie.com/',
    test13: 'https://test13.devv2.mobilemoxie.com/',
    test14: 'https://test14.devv2.mobilemoxie.com/',
    test15: 'https://test15.devv2.mobilemoxie.com/',
}
export const sortingOptionsPage = [
    {name: 'URL - A-Z', value: 'URL_ASC'},
    {name: 'URL - Z-A', value: 'URL_DESC'},
    {name: 'Country - A-Z', value: 'COUNTRY_ASC'},
    {name: 'Country - Z-A', value: 'COUNTRY_DESC'},
    {name: 'Device - A-Z', value: 'DEVICE_ASC'},
    {name: 'Device - Z-A', value: 'DEVICE_DESC'},
    {name: 'Last Test - Newest to Oldest', value: 'LAST_TEST_DESC'},
    {name: 'Last Test - Oldest to Newest', value: 'LAST_TEST_ASC'},
]
export const sortingOptionsSerp = [
    {name: 'Keyword - A-Z', value: 'KEYWORD_ASC'},
    {name: 'Keyword - Z-A', value: 'KEYWORD_DESC'},
    {name: 'Address - A-Z', value: 'ADDRESS_ASC'},
    {name: 'Address - Z-A', value: 'ADDRESS_DESC'},
    {name: 'Moxie Score - High to Low', value: 'MOXIE_DESC'},
    {name: 'Moxie Score - Low to High', value: 'MOXIE_ASC'},
    {name: 'Mess Score - High to Low', value: 'MESS_DESC'},
    {name: 'Mess Score - Low to High', value: 'MESS_ASC'},
    {name: 'Last Test - Newest to Oldest', value: 'LAST_TEST_DESC'},
    {name: 'Last Test - Oldest to Newest', value: 'LAST_TEST_ASC'},
]
export const sortingOptionsSerpSavedReports = [
    {name: 'Keyword - A-Z', value: 'KEYWORD_ASC'},
    {name: 'Keyword - Z-A', value: 'KEYWORD_DESC'},
    {name: 'Address - A-Z', value: 'ADDRESS_ASC'},
    {name: 'Address - Z-A', value: 'ADDRESS_DESC'},
]

export const countries = [
    {value: 'US', name: 'United States'},
    {value: 'GB', name: 'United Kingdom'},
    {value: 'AU', name: 'Australia'},
    {value: 'CA', name: 'Canada'},
    {value: 'DE', name: 'Germany'},
    {value: 'FR', name: 'France'},
    {value: 'ES', name: 'Spain'},
    {value: 'AL', name: 'Albania'},
    {value: 'DZ', name: 'Algeria'},
    {value: 'AO', name: 'Angola'},
    {value: 'AI', name: 'Anguilla'},
    {value: 'AG', name: 'Antigua and Barbuda'},
    {value: 'AR', name: 'Argentina'},
    {value: 'AM', name: 'Armenia'},
    {value: 'AT', name: 'Austria'},
    {value: 'AZ', name: 'Azerbaijan'},
    {value: 'BS', name: 'Bahamas'},
    {value: 'BH', name: 'Bahrain'},
    {value: 'BD', name: 'Bangladesh'},
    {value: 'BB', name: 'Barbados'},
    {value: 'BY', name: 'Belarus'},
    {value: 'BE', name: 'Belgium'},
    {value: 'BZ', name: 'Belize'},
    {value: 'BJ', name: 'Benin'},
    {value: 'BM', name: 'Bermuda'},
    {value: 'BT', name: 'Bhutan'},
    {value: 'BO', name: 'Bolivia'},
    {value: 'BW', name: 'Botswana'},
    {value: 'BR', name: 'Brazil'},
    {value: 'VG', name: 'British Virgin Islands'},
    {value: 'BN', name: 'Brunei'},
    {value: 'BG', name: 'Bulgaria'},
    {value: 'BF', name: 'Burkina Faso'},
    {value: 'KH', name: 'Cambodia'},
    {value: 'CV', name: 'Cape Verde'},
    {value: 'KY', name: 'Cayman Islands'},
    {value: 'TD', name: 'Chad'},
    {value: 'CL', name: 'Chile'},
    {value: 'CN', name: 'China'},
    {value: 'CO', name: 'Colombia'},
    {value: 'CR', name: 'Costa Rica'},
    {value: 'CI', name: 'Cote d\'Ivoire'},
    {value: 'HR', name: 'Croatia'},
    {value: 'CY', name: 'Cyprus'},
    {value: 'CZ', name: 'Czech Republic'},
    {value: 'CD', name: 'Democratic Republic of the Congo'},
    {value: 'DK', name: 'Denmark'},
    {value: 'DM', name: 'Dominica'},
    {value: 'DO', name: 'Dominican Republic'},
    {value: 'EC', name: 'Ecuador'},
    {value: 'EG', name: 'Egypt'},
    {value: 'SV', name: 'El Salvador'},
    {value: 'EE', name: 'Estonia'},
    {value: 'SZ', name: 'Eswatini'},
    {value: 'FM', name: 'Federated States Of Micronesia'},
    {value: 'FJ', name: 'Fiji'},
    {value: 'FI', name: 'Finland'},
    {value: 'GM', name: 'Gambia'},
    {value: 'GH', name: 'Ghana'},
    {value: 'GR', name: 'Greece'},
    {value: 'GD', name: 'Grenada'},
    {value: 'GT', name: 'Guatemala'},
    {value: 'GW', name: 'Guinea-Bissau'},
    {value: 'GY', name: 'Guyana'},
    {value: 'HN', name: 'Honduras'},
    {value: 'HK', name: 'Hong Kong'},
    {value: 'HU', name: 'Hungary'},
    {value: 'IS', name: 'Iceland'},
    {value: 'IN', name: 'India'},
    {value: 'ID', name: 'Indonesia'},
    {value: 'IR', name: 'Iran'},
    {value: 'IQ', name: 'Iraq'},
    {value: 'IE', name: 'Ireland'},
    {value: 'IM', name: 'Isle of Man'},
    {value: 'IL', name: 'Israel'},
    {value: 'IT', name: 'Italy'},
    {value: 'JM', name: 'Jamaica'},
    {value: 'JP', name: 'Japan'},
    {value: 'JE', name: 'Jersey'},
    {value: 'JO', name: 'Jordan'},
    {value: 'KZ', name: 'Kazakstan'},
    {value: 'KE', name: 'Kenya'},
    {value: 'KW', name: 'Kuwait'},
    {value: 'KG', name: 'Kyrgyzstan'},
    {value: 'LA', name: 'Lao People\'s Democratic Republic'},
    {value: 'LV', name: 'Latvia'},
    {value: 'LB', name: 'Lebanon'},
    {value: 'LR', name: 'Liberia'},
    {value: 'LT', name: 'Lithuania'},
    {value: 'LU', name: 'Luxembourg'},
    {value: 'MO', name: 'Macau'},
    {value: 'MG', name: 'Madagascar'},
    {value: 'MW', name: 'Malawi'},
    {value: 'MY', name: 'Malaysia'},
    {value: 'ML', name: 'Mali'},
    {value: 'MT', name: 'Malta'},
    {value: 'MR', name: 'Mauritania'},
    {value: 'MU', name: 'Mauritius'},
    {value: 'MX', name: 'Mexico'},
    {value: 'MN', name: 'Mongolia'},
    {value: 'ME', name: 'Montenegro'},
    {value: 'MS', name: 'Montserrat'},
    {value: 'MA', name: 'Morocco'},
    {value: 'MZ', name: 'Mozambique'},
    {value: 'MM', name: 'Myanmar'},
    {value: 'NA', name: 'Namibia'},
    {value: 'NP', name: 'Nepal'},
    {value: 'NL', name: 'Netherlands'},
    {value: 'NZ', name: 'New Zealand'},
    {value: 'NI', name: 'Nicaragua'},
    {value: 'NE', name: 'Niger'},
    {value: 'NG', name: 'Nigeria'},
    {value: 'MK', name: 'North Macedonia'},
    {value: 'NO', name: 'Norway'},
    {value: 'OM', name: 'Oman'},
    {value: 'PK', name: 'Pakistan'},
    {value: 'PW', name: 'Palau'},
    {value: 'PA', name: 'Panama'},
    {value: 'PG', name: 'Papua New Guinea'},
    {value: 'PY', name: 'Paraguay'},
    {value: 'PE', name: 'Peru'},
    {value: 'PH', name: 'Philippines'},
    {value: 'PL', name: 'Poland'},
    {value: 'PT', name: 'Portugal'},
    {value: 'QA', name: 'Qatar'},
    {value: 'CG', name: 'Republic Of Congo'},
    {value: 'KR', name: 'Republic Of Korea'},
    {value: 'MD', name: 'Republic Of Moldova'},
    {value: 'RO', name: 'Romania'},
    {value: 'RU', name: 'Russia'},
    {value: 'ST', name: 'Sao Tome and Principe'},
    {value: 'SA', name: 'Saudi Arabia'},
    {value: 'SN', name: 'Senegal'},
    {value: 'SC', name: 'Seychelles'},
    {value: 'SL', name: 'Sierra Leone'},
    {value: 'SG', name: 'Singapore'},
    {value: 'SK', name: 'Slovakia'},
    {value: 'SI', name: 'Slovenia'},
    {value: 'SB', name: 'Solomon Islands'},
    {value: 'ZA', name: 'South Africa'},
    {value: 'LK', name: 'Sri Lanka'},
    {value: 'KN', name: 'St. Kitts and Nevis'},
    {value: 'LC', name: 'St. Lucia'},
    {value: 'VC', name: 'St. Vincent and The Grenadines'},
    {value: 'SR', name: 'Suriname'},
    {value: 'SE', name: 'Sweden'},
    {value: 'CH', name: 'Switzerland'},
    {value: 'TW', name: 'Taiwan'},
    {value: 'TJ', name: 'Tajikistan'},
    {value: 'TZ', name: 'Tanzania'},
    {value: 'TH', name: 'Thailand'},
    {value: 'TT', name: 'Trinidad and Tobago'},
    {value: 'TN', name: 'Tunisia'},
    {value: 'TR', name: 'Turkey'},
    {value: 'TM', name: 'Turkmenistan'},
    {value: 'TC', name: 'Turks and Caicos'},
    {value: 'UG', name: 'Uganda'},
    {value: 'UA', name: 'Ukraine'},
    {value: 'AE', name: 'United Arab Emirates'},
    {value: 'UY', name: 'Uruguay'},
    {value: 'UZ', name: 'Uzbekistan'},
    {value: 'VE', name: 'Venezuela'},
    {value: 'VN', name: 'Vietnam'},
    {value: 'YE', name: 'Yemen'},
    {value: 'ZW', name: 'Zimbabwe'}
]

export const devices = [
    {
        name: 'Apple IOS',
        type: 'group',
        items: [
            {name: 'iPhone 14 Pro Max', value: '94'},
            {name: 'iPhone 14 Pro', value: '93'},
            {name: 'iPhone 14 Plus', value: '92'},
            {name: 'iPhone 14', value: '91'},
            {name: 'iPhone 13 Pro Max', value: '90'},
            {name: 'iPhone 13 Pro', value: '89'},
            {name: 'iPhone 13 mini', value: '88'},
            {name: 'iPhone 13', value: '87'},
            {name: 'iPhone 12 Pro Max', value: '70'},
            {name: 'iPhone 12 Pro', value: '69'},
            {name: 'iPhone 12 mini', value: '68'},
            {name: 'iPhone SE(2nd gen)', value: '67'},
            {name: 'iPhone 11 Pro Max', value: '66'},
            {name: 'iPhone 11 Pro', value: '65'},
            {name: 'iPhone 11', value: '64'},
            {name: 'iPhone XS', value: '53'},
            {name: 'iPhone XS Max', value: '54'},
            {name: 'iPhone XR', value: '52'},
            {name: 'iPhone X', value: '37'},
            {name: 'iPhone 8', value: '24'},
            {name: 'iPhone 8 Plus', value: '25'},
            {name: 'iPhone 7', value: '20'},
            {name: 'iPhone 7 Plus', value: '21'},
            {name: 'iPhone 6S', value: '1'},
            {name: 'iPhone 6S Plus', value: '2'},
            {name: 'iPhone 5', value: '51'}
        ]
    },
    {
        name: 'Android',
        type: 'group',
        items: [
            {name: 'Google Pixel 7 Pro', value: '100'},
            {name: 'Google Pixel 7', value: '99'},
            {name: 'Google Pixel 6 Pro', value: '98'},
            {name: 'Google Pixel 6a', value: '97'},
            {name: 'Google Pixel 6', value: '96'},
            {name: 'Google Pixel 5a', value: '95'},
            {name: 'Google Pixel 5', value: '76'},
            {name: 'Google Pixel 4a', value: '75'},
            {name: 'Google Pixel 4XL', value: '74'},
            {name: 'Google Pixel 4', value: '73'},
            {name: 'Google Pixel 3a XL', value: '72'},
            {name: 'Google Pixel 3a', value: '71'},
            {name: 'Google Pixel 3', value: '58'},
            {name: 'Google Pixel 3XL', value: '59'},
            {name: 'Google Pixel 2', value: '56'},
            {name: 'Google Pixel 2XL', value: '57'},
            {name: 'Google Pixel', value: '22'},
            {name: 'Google Pixel XL', value: '23'},
            {name: 'Google Nexus 6P', value: '5'},
            {name: 'Samsung Galaxy S20', value: '81'},
            {name: 'Samsung Galaxy S10', value: '80'},
            {name: 'Samsung Galaxy S9', value: '60'},
            {name: 'Samsung Galaxy S9+', value: '61'},
            {name: 'Samsung Galaxy S8', value: '26'},
            {name: 'Samsung Galaxy S8+', value: '27'},
            {name: 'Samsung Galaxy S6 Edge+', value: '12'},
            {name: 'Samsung Galaxy S5', value: '13'},
            {name: 'Samsung Galaxy Note20', value: '79'},
            {name: 'Samsung Galaxy Note10', value: '77'},
            {name: 'Samsung Galaxy Note9', value: '62'},
            {name: 'Samsung Galaxy Note8', value: '28'},
            {name: 'Samsung Galaxy Note5', value: '14'},
            {name: 'Samsung Galaxy Note4', value: '15'},
            {name: 'Samsung Galaxy J3 Eclipse', value: '29'},
            {name: 'Asus Zenfone 2', value: '4'},
            {name: 'BlackBerry KEYone', value: '31'},
            {name: 'HTC U11', value: '33'},
            {name: 'HTC One M9', value: '6'},
            {name: 'Huawei Honor 7', value: '7'},
            {name: 'LG G6', value: '30'},
            {name: 'LG G4', value: '8'},
            {name: 'LG X', value: '32'},
            {name: 'Motorola Moto X', value: '9'},
            {name: 'OnePlus 2', value: '11'},
            {name: 'Sony Xperia Z5', value: '16'},
            {name: 'Sony Xperia Z5 Compact', value: '17'},
            {name: 'Xiaomi Redmi 2', value: '19'},
            {name: 'Xiaomi Mi Note', value: '18'}
        ]
    },
    {
        name: 'Windows OS',
        type: 'group',
        items: [
            {name: 'Cube WP10', value: '34'},
            {name: 'HP Elite X3', value: '35'},
            {name: 'Microsoft Lumia 950', value: '36'},
            {name: 'Nokia Lumia 630', value: '10'}
        ]
    },
    {
        name: 'Desktop',
        type: 'group',
        items: [
            {name: 'Desktop', value: '63'}
        ]
    },
    {
        name: 'Google Crawlers',
        type: 'group',
        items: [
            {name: 'Googlebot Smartphone', value: '86'}
        ]
    },
    {
        name: 'None',
        type: 'group',
        items: [
            {name: 'None', value: '0'}
        ]
    }
]

export const rankingsDevices = [
    {
        name: 'Apple IOS',
        type: 'group',
        items: [
            {name: 'iPhone 14 Pro Max', value: '94'},
            {name: 'iPhone 14 Pro', value: '93'},
            {name: 'iPhone 14 Plus', value: '92'},
            {name: 'iPhone 14', value: '91'},
            {name: 'iPhone 13 Pro Max', value: '90'},
            {name: 'iPhone 13 Pro', value: '89'},
            {name: 'iPhone 13 mini', value: '88'},
            {name: 'iPhone 13', value: '87'},
            {name: 'iPhone 12 Pro Max', value: '70'},
            {name: 'iPhone 12 Pro', value: '69'},
            {name: 'iPhone 12 mini', value: '68'},
            {name: 'iPhone SE(2nd gen)', value: '67'},
            {name: 'iPhone 11 Pro Max', value: '66'},
            {name: 'iPhone 11 Pro', value: '65'},
            {name: 'iPhone 11', value: '64'},
            {name: 'iPhone XS', value: '53'},
            {name: 'iPhone XS Max', value: '54'},
            {name: 'iPhone XR', value: '52'},
            {name: 'iPhone X', value: '37'},
            {name: 'iPhone 8', value: '24'},
            {name: 'iPhone 8 Plus', value: '25'},
            {name: 'iPhone 7', value: '20'},
            {name: 'iPhone 7 Plus', value: '21'},
            {name: 'iPhone 6S', value: '1'},
            {name: 'iPhone 6S Plus', value: '2'},
            {name: 'iPhone 5', value: '51'}
        ]
    },
    {
        name: 'Android',
        type: 'group',
        items: [
            {name: 'Google Pixel 7 Pro', value: '100'},
            {name: 'Google Pixel 7', value: '99'},
            {name: 'Google Pixel 6 Pro', value: '98'},
            {name: 'Google Pixel 6a', value: '97'},
            {name: 'Google Pixel 6', value: '96'},
            {name: 'Google Pixel 5a', value: '95'},
            {name: 'Google Pixel 5', value: '76'},
            {name: 'Google Pixel 4a', value: '75'},
            {name: 'Google Pixel 4XL', value: '74'},
            {name: 'Google Pixel 4', value: '73'},
            {name: 'Google Pixel 3a XL', value: '72'},
            {name: 'Google Pixel 3a', value: '71'},
            {name: 'Google Pixel 3', value: '58'},
            {name: 'Google Pixel 3XL', value: '59'},
            {name: 'Google Pixel 2', value: '56'},
            {name: 'Google Pixel 2XL', value: '57'},
            {name: 'Google Pixel', value: '22'},
            {name: 'Google Pixel XL', value: '23'},
            {name: 'Google Nexus 6P', value: '5'},
            {name: 'Samsung Galaxy S20', value: '81'},
            {name: 'Samsung Galaxy S10', value: '80'},
            {name: 'Samsung Galaxy S9', value: '60'},
            {name: 'Samsung Galaxy S9+', value: '61'},
            {name: 'Samsung Galaxy S8', value: '26'},
            {name: 'Samsung Galaxy S8+', value: '27'},
            {name: 'Samsung Galaxy S6 Edge+', value: '12'},
            {name: 'Samsung Galaxy S5', value: '13'},
            {name: 'Samsung Galaxy Note20', value: '79'},
            {name: 'Samsung Galaxy Note10', value: '77'},
            {name: 'Samsung Galaxy Note9', value: '62'},
            {name: 'Samsung Galaxy Note8', value: '28'},
            {name: 'Samsung Galaxy Note5', value: '14'},
            {name: 'Samsung Galaxy Note4', value: '15'},
            {name: 'Samsung Galaxy J3 Eclipse', value: '29'},
            {name: 'Asus Zenfone 2', value: '4'},
            {name: 'BlackBerry KEYone', value: '31'},
            {name: 'HTC U11', value: '33'},
            {name: 'HTC One M9', value: '6'},
            {name: 'Huawei Honor 7', value: '7'},
            {name: 'LG G6', value: '30'},
            {name: 'LG G4', value: '8'},
            {name: 'LG X', value: '32'},
            {name: 'Motorola Moto X', value: '9'},
            {name: 'OnePlus 2', value: '11'},
            {name: 'Sony Xperia Z5', value: '16'},
            {name: 'Sony Xperia Z5 Compact', value: '17'},
            {name: 'Xiaomi Redmi 2', value: '19'},
            {name: 'Xiaomi Mi Note', value: '18'}
        ]
    },
    {
        name: 'Windows OS',
        type: 'group',
        items: [
            {name: 'Cube WP10', value: '34'},
            {name: 'HP Elite X3', value: '35'},
            {name: 'Microsoft Lumia 950', value: '36'},
            {name: 'Nokia Lumia 630', value: '10'}
        ]
    },
    {
        name: 'Desktop',
        type: 'group',
        items: [
            {name: 'Desktop', value: '63'}
        ]
    },
    {
        name: 'None',
        type: 'group',
        items: [
            {name: 'None', value: '0'}
        ]
    }
]

export const appDevices = [
    {
        name: 'Apple IOS',
        type: 'group',
        items: [
            {name: 'iPhone 14 Pro Max', value: '94'},
            {name: 'iPhone 14 Pro', value: '93'},
            {name: 'iPhone 14 Plus', value: '92'},
            {name: 'iPhone 14', value: '91'},
            {name: 'iPhone 13 Pro Max', value: '90'},
            {name: 'iPhone 13 Pro', value: '89'},
            {name: 'iPhone 13 mini', value: '88'},
            {name: 'iPhone 13', value: '87'},
            {name: 'iPhone 12 Pro Max', value: '70'},
            {name: 'iPhone 12 Pro', value: '69'},
            {name: 'iPhone 12 mini', value: '68'},
            {name: 'iPhone SE(2nd gen)', value: '67'},
            {name: 'iPhone 11 Pro Max', value: '66'},
            {name: 'iPhone 11 Pro', value: '65'},
            {name: 'iPhone 11', value: '64'},
            {name: 'iPhone XS', value: '53'},
            {name: 'iPhone XS Max', value: '54'},
            {name: 'iPhone XR', value: '52'},
            {name: 'iPhone X', value: '37'},
            {name: 'iPhone 8', value: '24'},
            {name: 'iPhone 8 Plus', value: '25'},
            {name: 'iPhone 7', value: '20'},
            {name: 'iPhone 7 Plus', value: '21'},
            {name: 'iPhone 6S', value: '1'},
            {name: 'iPhone 6S Plus', value: '2'},
            {name: 'iPhone 5', value: '51'}
        ]
    },
    {
        name: 'Android',
        type: 'group',
        items: [
            {name: 'Google Pixel 7 Pro', value: '100'},
            {name: 'Google Pixel 7', value: '99'},
            {name: 'Google Pixel 6 Pro', value: '98'},
            {name: 'Google Pixel 6a', value: '97'},
            {name: 'Google Pixel 6', value: '96'},
            {name: 'Google Pixel 5a', value: '95'},
            {name: 'Google Pixel 5', value: '76'},
            {name: 'Google Pixel 4a', value: '75'},
            {name: 'Google Pixel 4XL', value: '74'},
            {name: 'Google Pixel 4', value: '73'},
            {name: 'Google Pixel 3a XL', value: '72'},
            {name: 'Google Pixel 3a', value: '71'},
            {name: 'Google Pixel 3', value: '58'},
            {name: 'Google Pixel 3XL', value: '59'},
            {name: 'Google Pixel 2', value: '56'},
            {name: 'Google Pixel 2XL', value: '57'},
            {name: 'Google Pixel', value: '22'},
            {name: 'Google Pixel XL', value: '23'},
            {name: 'Google Nexus 6P', value: '5'},
            {name: 'Samsung Galaxy S20', value: '81'},
            {name: 'Samsung Galaxy S10', value: '80'},
            {name: 'Samsung Galaxy S9', value: '60'},
            {name: 'Samsung Galaxy S9+', value: '61'},
            {name: 'Samsung Galaxy S8', value: '26'},
            {name: 'Samsung Galaxy S8+', value: '27'},
            {name: 'Samsung Galaxy S6 Edge+', value: '12'},
            {name: 'Samsung Galaxy S5', value: '13'},
            {name: 'Samsung Galaxy Note20', value: '79'},
            {name: 'Samsung Galaxy Note10', value: '77'},
            {name: 'Samsung Galaxy Note9', value: '62'},
            {name: 'Samsung Galaxy Note8', value: '28'},
            {name: 'Samsung Galaxy Note5', value: '14'},
            {name: 'Samsung Galaxy Note4', value: '15'},
            {name: 'Samsung Galaxy J3 Eclipse', value: '29'},
            {name: 'Asus Zenfone 2', value: '4'},
            {name: 'BlackBerry KEYone', value: '31'},
            {name: 'HTC U11', value: '33'},
            {name: 'HTC One M9', value: '6'},
            {name: 'Huawei Honor 7', value: '7'},
            {name: 'LG G6', value: '30'},
            {name: 'LG G4', value: '8'},
            {name: 'LG X', value: '32'},
            {name: 'Motorola Moto X', value: '9'},
            {name: 'OnePlus 2', value: '11'},
            {name: 'Sony Xperia Z5', value: '16'},
            {name: 'Sony Xperia Z5 Compact', value: '17'},
            {name: 'Xiaomi Redmi 2', value: '19'},
            {name: 'Xiaomi Mi Note', value: '18'}
        ]
    },
    {
        name: 'Windows OS',
        type: 'group',
        items: [
            {name: 'Cube WP10', value: '34'},
            {name: 'HP Elite X3', value: '35'},
            {name: 'Microsoft Lumia 950', value: '36'},
            {name: 'Nokia Lumia 630', value: '10'}
        ]
    },
    {
        name: 'None',
        type: 'group',
        items: [
            {name: 'None', value: '0'}
        ]
    }
]

export const defaultDevices = {
    'IOS': {
        id: 69,
        name: 'iPhone 12 Pro',
        OS: 'IOS',
        width: 371,
        height: 850,
        thumbSmallHeight: 180,
        thumbLargeHeight: 624,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 200,
        thumbSmallContainerMarginTop: 30
    },
    'ANDROID': {
        id: 76,
        name: 'Google Pixel 5',
        OS: 'Android',
        width: 367,
        height: 850,
        thumbSmallHeight: 188,
        thumbLargeHeight: 642,
        thumbSmallWidth: 142,
        thumbLargeWidth: 335,
        thumbSmallContainerHeight: 200,
        thumbSmallContainerMarginTop: 30
    },
    'DESKTOP': {
        id: 63,
        name: 'Desktop',
        OS: 'Desktop',
        width: 1280,
        height: 1024,
        thumbSmallHeight: 182,
        thumbLargeHeight: 370,
        thumbSmallWidth: 248,
        thumbLargeWidth: 454,
        thumbSmallContainerHeight: 134,
        thumbSmallContainerMarginTop: 30
    },
}

export const deviceProperties = {
    1: {
        name: 'iPhone 6S',
        OS: 'Apple iOS',
        width: 378,
        height: 667,
        thumbSmallHeight: 188,
        thumbLargeHeight: 636,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 197,
        thumbSmallContainerMarginTop: 30
    },
    2: {
        name: 'iPhone 6S Plus',
        OS: 'Apple iOS',
        width: 417,
        height: 854,
        thumbSmallHeight: 184,
        thumbLargeHeight: 636,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 188,
        thumbSmallContainerMarginTop: 30
    },
    4: {
        name: 'Asus Zenfone 2',
        OS: 'Android',
        width: 412,
        height: 915,
        thumbSmallHeight: 177,
        thumbLargeHeight: 601,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 200,
        thumbSmallContainerMarginTop: 30
    },
    5: {
        name: 'Google Nexus 6P',
        OS: 'Android',
        width: 412,
        height: 920,
        thumbSmallHeight: 181,
        thumbLargeHeight: 607,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 191,
        thumbSmallContainerMarginTop: 30
    },
    6: {
        name: 'HTC One M9',
        OS: 'Android',
        width: 361,
        height: 240,
        thumbSmallHeight: 175,
        thumbLargeHeight: 589,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 212,
        thumbSmallContainerMarginTop: 30
    },
    7: {
        name: 'Huawei Honor 7',
        OS: 'Android',
        width: 362,
        height: 640,
        thumbSmallHeight: 175,
        thumbLargeHeight: 592,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 205,
        thumbSmallContainerMarginTop: 30
    },
    8: {
        name: 'LG G4',
        OS: 'Android',
        width: 417,
        height: 480,
        thumbSmallHeight: 175,
        thumbLargeHeight: 574,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 212,
        thumbSmallContainerMarginTop: 30
    },
    9: {
        name: 'Motorola Moto X',
        OS: 'Android',
        width: 358,
        height: 480,
        thumbSmallHeight: 173,
        thumbLargeHeight: 585,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 212,
        thumbSmallContainerMarginTop: 30
    },
    10: {
        name: 'Nokia Lumia 630',
        OS: 'Windows OS',
        width: 323,
        height: 569,
        thumbSmallHeight: 186,
        thumbLargeHeight: 636,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 200,
        thumbSmallContainerMarginTop: 30
    },
    11: {
        name: 'OnePlus 2',
        OS: 'Android',
        width: 364,
        height: 640,
        thumbSmallHeight: 175,
        thumbLargeHeight: 591,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 212,
        thumbSmallContainerMarginTop: 30
    },
    12: {
        name: 'Samsung Galaxy S6 Edge+',
        OS: 'Android',
        width: 430,
        height: 764,
        thumbSmallHeight: 175,
        thumbLargeHeight: 578,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 212,
        thumbSmallContainerMarginTop: 30
    },
    13: {
        name: 'Samsung Galaxy S5',
        OS: 'Android',
        width: 362,
        height: 640,
        thumbSmallHeight: 179,
        thumbLargeHeight: 602,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 212,
        thumbSmallContainerMarginTop: 30
    },
    14: {
        name: 'Samsung Galaxy Note5',
        OS: 'Android',
        width: 412,
        height: 732,
        thumbSmallHeight: 176,
        thumbLargeHeight: 589,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 212,
        thumbSmallContainerMarginTop: 30
    },
    15: {
        name: 'Samsung Galaxy Note4',
        OS: 'Android',
        width: 433,
        height: 764,
        thumbSmallHeight: 175,
        thumbLargeHeight: 587,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 184,
        thumbSmallContainerMarginTop: 30
    },
    16: {
        name: 'Sony Xperia Z5',
        OS: 'Android',
        width: 416,
        height: 736,
        thumbSmallHeight: 179,
        thumbLargeHeight: 609,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 207,
        thumbSmallContainerMarginTop: 30
    },
    17: {
        name: 'Sony Xperia Z5 Compact',
        OS: 'Android',
        width: 363,
        height: 640,
        thumbSmallHeight: 180,
        thumbLargeHeight: 615,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 212,
        thumbSmallContainerMarginTop: 30
    },
    18: {
        name: 'Xiaomi Mi Note',
        OS: 'Android',
        width: 430,
        height: 764,
        thumbSmallHeight: 174,
        thumbLargeHeight: 587,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 212,
        thumbSmallContainerMarginTop: 30
    },
    19: {
        name: 'Xiaomi Redmi 2',
        OS: 'Android',
        width: 363,
        height: 640,
        thumbSmallHeight: 181,
        thumbLargeHeight: 617,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 207,
        thumbSmallContainerMarginTop: 30
    },
    20: {
        name: 'iPhone 7',
        OS: 'Apple iOS',
        width: 378,
        height: 667,
        thumbSmallHeight: 183,
        thumbLargeHeight: 636,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 197,
        thumbSmallContainerMarginTop: 30
    },
    21: {
        name: 'iPhone 7 Plus',
        OS: 'Apple iOS',
        width: 417,
        height: 854,
        thumbSmallHeight: 182,
        thumbLargeHeight: 624,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 193,
        thumbSmallContainerMarginTop: 30
    },
    22: {
        name: 'Google Pixel',
        OS: 'Android',
        width: 375,
        height: 915,
        thumbSmallHeight: 180,
        thumbLargeHeight: 604,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 188,
        thumbSmallContainerMarginTop: 30
    },
    23: {
        name: 'Google Pixel XL',
        OS: 'Android',
        width: 417,
        height: 854,
        thumbSmallHeight: 181,
        thumbLargeHeight: 625,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 192,
        thumbSmallContainerMarginTop: 30
    },
    24: {
        name: 'iPhone 8',
        OS: 'Apple iOS',
        width: 378,
        height: 667,
        thumbSmallHeight: 184,
        thumbLargeHeight: 636,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 195,
        thumbSmallContainerMarginTop: 30
    },
    25: {
        name: 'iPhone 8 Plus',
        OS: 'Apple iOS',
        width: 418,
        height: 736,
        thumbSmallHeight: 182,
        thumbLargeHeight: 625,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 194,
        thumbSmallContainerMarginTop: 30
    },
    26: {
        name: 'Samsung Galaxy S8',
        OS: 'Android',
        width: 363,
        height: 740,
        thumbSmallHeight: 186,
        thumbLargeHeight: 616,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 212,
        thumbSmallContainerMarginTop: 30
    },
    27: {
        name: 'Samsung Galaxy S8+',
        OS: 'Android',
        width: 393,
        height: 795,
        thumbSmallHeight: 181,
        thumbLargeHeight: 615,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 212,
        thumbSmallContainerMarginTop: 30
    },
    28: {
        name: 'Samsung Galaxy Note8',
        OS: 'Android',
        width: 402,
        height: 827,
        thumbSmallHeight: 183,
        thumbLargeHeight: 614,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 212,
        thumbSmallContainerMarginTop: 30
    },
    29: {
        name: 'Samsung Galaxy J3 Eclipse',
        OS: 'Android',
        width: 359,
        height: 643,
        thumbSmallHeight: 179,
        thumbLargeHeight: 609,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 212,
        thumbSmallContainerMarginTop: 30
    },
    30: {
        name: 'LG G6',
        OS: 'Android',
        width: 362,
        height: 728,
        thumbSmallHeight: 183,
        thumbLargeHeight: 619,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 212,
        thumbSmallContainerMarginTop: 30
    },
    31: {
        name: 'BlackBerry KEYone',
        OS: 'Android',
        width: 362,
        height: 845,
        thumbSmallHeight: 184,
        thumbLargeHeight: 626,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 205,
        thumbSmallContainerMarginTop: 72
    },
    32: {
        name: 'LG X',
        OS: 'Android',
        width: 378,
        height: 670,
        thumbSmallHeight: 177,
        thumbLargeHeight: 609,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 212,
        thumbSmallContainerMarginTop: 30
    },
    33: {
        name: 'HTC U11',
        OS: 'Android',
        width: 382,
        height: 675,
        thumbSmallHeight: 180,
        thumbLargeHeight: 618,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 195,
        thumbSmallContainerMarginTop: 30
    },
    34: {
        name: 'Cube WP10',
        OS: 'Windows OS',
        width: 500,
        height: 886,
        thumbSmallHeight: 170,
        thumbLargeHeight: 568,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 212,
        thumbSmallContainerMarginTop: 30
    },
    35: {
        name: 'HP Elite X3',
        OS: 'Windows OS',
        width: 423,
        height: 707,
        thumbSmallHeight: 176,
        thumbLargeHeight: 591,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 212,
        thumbSmallContainerMarginTop: 30
    },
    36: {
        name: 'Microsoft Lumia 950',
        OS: 'Windows OS',
        width: 368,
        height: 650,
        thumbSmallHeight: 180,
        thumbLargeHeight: 608,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 212,
        thumbSmallContainerMarginTop: 30
    },
    37: {
        name: 'iPhone X',
        OS: 'Apple iOS',
        width: 375,
        height: 812,
        thumbSmallHeight: 181,
        thumbLargeHeight: 624,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 207,
        thumbSmallContainerMarginTop: 30
    },
    51: {
        name: 'iPhone 5',
        OS: 'Apple iOS',
        width: 308,
        height: 480,
        thumbSmallHeight: 194,
        thumbLargeHeight: 636,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 208,
        thumbSmallContainerMarginTop: 30
    },
    52: {
        name: 'iPhone XR',
        OS: 'Apple iOS',
        width: 414,
        height: 896,
        thumbSmallHeight: 181,
        thumbLargeHeight: 625,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 208,
        thumbSmallContainerMarginTop: 30
    },
    53: {
        name: 'iPhone XS',
        OS: 'Apple iOS',
        width: 375,
        height: 812,
        thumbSmallHeight: 182,
        thumbLargeHeight: 624,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 207,
        thumbSmallContainerMarginTop: 30
    },
    54: {
        name: 'iPhone XS Max',
        OS: 'Apple iOS',
        width: 414,
        height: 896,
        thumbSmallHeight: 196,
        thumbLargeHeight: 636,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 221,
        thumbSmallContainerMarginTop: 30
    },
    56: {
        name: 'Google Pixel 2',
        OS: 'Android',
        width: 411,
        height: 950,
        thumbSmallHeight: 181,
        thumbLargeHeight: 626,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 213,
        thumbSmallContainerMarginTop: 34
    },
    57: {
        name: 'Google Pixel 2XL',
        OS: 'Android',
        width: 411,
        height: 985,
        thumbSmallHeight: 186,
        thumbLargeHeight: 636,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 226,
        thumbSmallContainerMarginTop: 30
    },
    58: {
        name: 'Google Pixel 3',
        OS: 'Android',
        width: 393,
        height: 935,
        thumbSmallHeight: 188,
        thumbLargeHeight: 642,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 227,
        thumbSmallContainerMarginTop: 30
    },
    59: {
        name: 'Google Pixel 3XL',
        OS: 'Android',
        width: 412,
        height: 846,
        thumbSmallHeight: 186,
        thumbLargeHeight: 636,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 232,
        thumbSmallContainerMarginTop: 30
    },
    60: {
        name: 'Samsung Galaxy S9',
        OS: 'Android',
        width: 360,
        height: 740,
        thumbSmallHeight: 186,
        thumbLargeHeight: 629,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 212,
        thumbSmallContainerMarginTop: 30
    },
    61: {
        name: 'Samsung Galaxy S9+',
        OS: 'Android',
        width: 412,
        height: 846,
        thumbSmallHeight: 186,
        thumbLargeHeight: 615,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 212,
        thumbSmallContainerMarginTop: 30
    },
    62: {
        name: 'Samsung Galaxy Note9',
        OS: 'Android',
        width: 414,
        height: 846,
        thumbSmallHeight: 186,
        thumbLargeHeight: 636,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 212,
        thumbSmallContainerMarginTop: 30
    },
    63: {
        name: 'Desktop',
        OS: 'Desktop',
        width: 1280,
        height: 1024,
        thumbSmallHeight: 184,
        thumbLargeHeight: 370,
        thumbSmallWidth: 248,
        thumbLargeWidth: 454,
        thumbSmallContainerHeight: 122,
        thumbSmallContainerMarginTop: 30
    },
    64: {
        name: 'iPhone 11',
        OS: 'Apple iOS',
        width: 355,
        height: 850,
        thumbSmallHeight: 183,
        thumbLargeHeight: 713,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 203,
        thumbSmallContainerMarginTop: 30
    },
    65: {
        name: 'iPhone 11 Pro',
        OS: 'Apple iOS',
        width: 371,
        height: 850,
        thumbSmallHeight: 194,
        thumbLargeHeight: 757,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 216,
        thumbSmallContainerMarginTop: 30
    },
    66: {
        name: 'iPhone 11 Pro Max',
        OS: 'Apple iOS',
        width: 403,
        height: 850,
        thumbSmallHeight: 193,
        thumbLargeHeight: 758,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 216,
        thumbSmallContainerMarginTop: 30
    },
    67: {
        name: 'iPhone SE(2nd gen)',
        OS: 'Apple iOS',
        width: 374,
        height: 850,
        thumbSmallHeight: 233,
        thumbLargeHeight: 768,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 197,
        thumbSmallContainerMarginTop: 30
    },
    68: {
        name: 'iPhone 12 mini',
        OS: 'Apple iOS',
        width: 331,
        height: 850,
        thumbSmallHeight: 199,
        thumbLargeHeight: 785,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 224,
        thumbSmallContainerMarginTop: 30
    },
    69: {
        name: 'iPhone 12 Pro',
        OS: 'Apple iOS',
        width: 371,
        height: 850,
        thumbSmallHeight: 180,
        thumbLargeHeight: 624,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 217,
        thumbSmallContainerMarginTop: 30
    },
    70: {
        name: 'iPhone 12 Pro Max',
        OS: 'Apple iOS',
        width: 392,
        height: 850,
        thumbSmallHeight: 194,
        thumbLargeHeight: 763,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 217,
        thumbSmallContainerMarginTop: 30
    },
    71: {
        name: 'Google Pixel 3a',
        OS: 'Android',
        width: 370,
        height: 790,
        thumbSmallHeight: 240,
        thumbLargeHeight: 809,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 224,
        thumbSmallContainerMarginTop: 30
    },
    72: {
        name: 'Google Pixel 3a XL',
        OS: 'Android',
        width: 410,
        height: 850,
        thumbSmallHeight: 230,
        thumbLargeHeight: 769,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 214,
        thumbSmallContainerMarginTop: 30
    },
    73: {
        name: 'Google Pixel 4',
        OS: 'Android',
        width: 355,
        height: 850,
        thumbSmallHeight: 243,
        thumbLargeHeight: 814,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 222,
        thumbSmallContainerMarginTop: 30
    },
    74: {
        name: 'Google Pixel 4XL',
        OS: 'Android',
        width: 366,
        height: 850,
        thumbSmallHeight: 240,
        thumbLargeHeight: 812,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 232,
        thumbSmallContainerMarginTop: 30
    },
    75: {
        name: 'Google Pixel 4a',
        OS: 'Android',
        width: 366,
        height: 850,
        thumbSmallHeight: 243,
        thumbLargeHeight: 805,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 232,
        thumbSmallContainerMarginTop: 30
    },
    76: {
        name: 'Google Pixel 5',
        OS: 'Android',
        width: 367,
        height: 850,
        thumbSmallHeight: 188,
        thumbLargeHeight: 642,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 222,
        thumbSmallContainerMarginTop: 30
    },
    77: {
        name: 'Samsung Galaxy Note10',
        OS: 'Android',
        width: 390,
        height: 850,
        thumbSmallHeight: 244,
        thumbLargeHeight: 810,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 235,
        thumbSmallContainerMarginTop: 30
    },
    79: {
        name: 'Samsung Galaxy Note20',
        OS: 'Android',
        width: 386,
        height: 850,
        thumbSmallHeight: 243,
        thumbLargeHeight: 810,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 212,
        thumbSmallContainerMarginTop: 30
    },
    80: {
        name: 'Samsung Galaxy S10',
        OS: 'Android',
        width: 383,
        height: 850,
        thumbSmallHeight: 241,
        thumbLargeHeight: 813,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 212,
        thumbSmallContainerMarginTop: 30
    },
    81: {
        name: 'Samsung Galaxy S20',
        OS: 'Android',
        width: 386,
        height: 850,
        thumbSmallHeight: 243,
        thumbLargeHeight: 813,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 212,
        thumbSmallContainerMarginTop: 30
    },
    86: {
        name: 'Googlebot Smartphone',
        OS: 'Google Crawlers',
        width: 586,
        height: 1050,
        thumbSmallHeight: 243,
        thumbLargeHeight: 813,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 212,
        thumbSmallContainerMarginTop: 30
    },
    87: {
        name: 'iPhone 13',
        OS: 'Apple iOS',
        width: 390,
        height: 844,
        thumbSmallHeight: 193,
        thumbLargeHeight: 758,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 177,
        thumbSmallContainerMarginTop: 30
    },
    88: {
        name: 'iPhone 13 mini',
        OS: 'Apple iOS',
        width: 375,
        height: 812,
        thumbSmallHeight: 193,
        thumbLargeHeight: 758,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 178,
        thumbSmallContainerMarginTop: 30
    },
    89: {
        name: 'iPhone 13 Pro',
        OS: 'Apple iOS',
        width: 382,
        height: 844,
        thumbSmallHeight: 193,
        thumbLargeHeight: 758,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 180,
        thumbSmallContainerMarginTop: 30
    },
    90: {
        name: 'iPhone 13 Pro Max',
        OS: 'Apple iOS',
        width: 372,
        height: 926,
        thumbSmallHeight: 193,
        thumbLargeHeight: 758,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 177,
        thumbSmallContainerMarginTop: 30
    },
    91: {
        name: 'iPhone 14',
        OS: 'Apple iOS',
        width: 374,
        height: 844,
        thumbSmallHeight: 193,
        thumbLargeHeight: 758,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 180,
        thumbSmallContainerMarginTop: 30
    },
    92: {
        name: 'iPhone 14 Plus',
        OS: 'Apple iOS',
        width: 393,
        height: 852,
        thumbSmallHeight: 193,
        thumbLargeHeight: 758,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 179,
        thumbSmallContainerMarginTop: 30
    },
    93: {
        name: 'iPhone 14 Pro',
        OS: 'Apple iOS',
        width: 428,
        height: 926,
        thumbSmallHeight: 193,
        thumbLargeHeight: 758,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 186,
        thumbSmallContainerMarginTop: 30
    },
    94: {
        name: 'iPhone 14 Pro Max',
        OS: 'Apple iOS',
        width: 430,
        height: 932,
        thumbSmallHeight: 193,
        thumbLargeHeight: 758,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 186,
        thumbSmallContainerMarginTop: 30
    },
    95: {
        name: 'Google Pixel 5a',
        OS: 'Apple iOS',
        width: 367,
        height: 850,
        thumbSmallHeight: 193,
        thumbLargeHeight: 758,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 174,
        thumbSmallContainerMarginTop: 30
    },
    96: {
        name: 'Google Pixel 6',
        OS: 'Apple iOS',
        width: 412,
        height: 915,
        thumbSmallHeight: 193,
        thumbLargeHeight: 758,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 216,
        thumbSmallContainerMarginTop: 30
    },
    97: {
        name: 'Google Pixel 6a',
        OS: 'Apple iOS',
        width: 412,
        height: 915,
        thumbSmallHeight: 193,
        thumbLargeHeight: 758,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 188,
        thumbSmallContainerMarginTop: 30
    },
    98: {
        name: 'Google Pixel 6 Pro',
        OS: 'Apple iOS',
        width: 412,
        height: 892,
        thumbSmallHeight: 193,
        thumbLargeHeight: 758,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 188,
        thumbSmallContainerMarginTop: 30
    },
    99: {
        name: 'Google Pixel 7',
        OS: 'Apple iOS',
        width: 331,
        height: 850,
        thumbSmallHeight: 193,
        thumbLargeHeight: 758,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 186,
        thumbSmallContainerMarginTop: 30
    },
    100: {
        name: 'Google Pixel 7 Pro',
        OS: 'Apple iOS',
        width: 331,
        height: 850,
        thumbSmallHeight: 193,
        thumbLargeHeight: 758,
        thumbSmallWidth: 142,
        thumbLargeWidth: 350,
        thumbSmallContainerHeight: 186,
        thumbSmallContainerMarginTop: 30
    }
}

export const centroids = {
    AD: {lat: 42.54229102, long: 1.560543779},
    AE: {lat: 23.90528188, long: 54.3001671},
    AF: {lat: 33.83523073, long: 66.00473366},
    AG: {lat: 17.2774996, long: -61.79469343},
    AI: {lat: 18.2239595, long: -63.06498927},
    AL: {lat: 41.14244989, long: 20.04983396},
    AM: {lat: 40.28952569, long: 44.92993276},
    AO: {lat: -12.29336054, long: 17.53736768},
    AQ: {lat: -80.50857913, long: 19.92108951},
    AR: {lat: -35.3813488, long: -65.17980693},
    AS: {lat: -14.30445997, long: -170.7180257},
    AT: {lat: 47.58549439, long: 14.1264761},
    AU: {lat: -25.73288704, long: 134.4910001},
    AW: {lat: 12.52088038, long: -69.98267711},
    AX: {lat: 60.21488688, long: 19.95328768},
    AZ: {lat: 40.28827235, long: 47.54599879},
    BA: {lat: 44.17450125, long: 17.76876733},
    BB: {lat: 13.18145428, long: -59.559797},
    BD: {lat: 23.86731158, long: 90.23812743},
    BE: {lat: 50.63981576, long: 4.640651139},
    BF: {lat: 12.26953846, long: -1.754566009},
    BG: {lat: 42.76890318, long: 25.21552909},
    BH: {lat: 26.04205135, long: 50.54196932},
    BI: {lat: -3.359396657, long: 29.87512156},
    BJ: {lat: 9.641759702, long: 2.327852544},
    BL: {lat: 17.89880451, long: -62.84067779},
    BM: {lat: 32.31367802, long: -64.7545589},
    BN: {lat: 4.519689575, long: 114.7220304},
    BO: {lat: -16.70814787, long: -64.68538645},
    BR: {lat: -10.78777702, long: -53.09783113},
    BS: {lat: 24.29036702, long: -76.62843038},
    BT: {lat: 27.41106589, long: 90.40188155},
    BW: {lat: -22.18403213, long: 23.79853368},
    BY: {lat: 53.53131377, long: 28.03209307},
    BZ: {lat: 17.20027509, long: -88.71010486},
    CA: {lat: 61.36206324, long: -98.30777028},
    CD: {lat: -2.87746289, long: 23.64396107},
    CF: {lat: 6.56823297, long: 20.46826831},
    CG: {lat: -0.837874631, long: 15.21965762},
    CH: {lat: 46.79785878, long: 8.208674706},
    CI: {lat: 7.628426202, long: -5.5692157},
    CK: {lat: -21.21927288, long: -159.7872422},
    CL: {lat: -37.73070989, long: -71.38256213},
    CM: {lat: 5.69109849, long: 12.73964156},
    CN: {lat: 36.56176546, long: 103.8190735},
    CO: {lat: 3.913834307, long: -73.08114582},
    CR: {lat: 9.976344638, long: -84.19208768},
    CU: {lat: 21.62289528, long: -79.01605384},
    CV: {lat: 15.95523324, long: -23.9598882},
    CW: {lat: 12.19551675, long: -68.97119369},
    CY: {lat: 34.91667211, long: 33.0060022},
    CZ: {lat: 49.73341233, long: 15.31240163},
    DE: {lat: 51.10698181, long: 10.38578051},
    DJ: {lat: 11.74871806, long: 42.5606754},
    DK: {lat: 55.98125296, long: 10.02800992},
    DM: {lat: 15.4394702, long: -61.357726},
    DO: {lat: 18.89433082, long: -70.50568896},
    DZ: {lat: 28.15893849, long: 2.617323009},
    EC: {lat: -1.423816125, long: -78.75201923},
    EE: {lat: 58.67192972, long: 25.54248537},
    EG: {lat: 26.49593311, long: 29.86190099},
    EH: {lat: 24.22956739, long: -12.21982755},
    ER: {lat: 15.36186618, long: 38.84617011},
    ES: {lat: 40.24448698, long: -3.647550473},
    ET: {lat: 8.622786793, long: 39.60080098},
    FI: {lat: 64.49884603, long: 26.2746656},
    FJ: {lat: -17.42858032, long: 165.4519543},
    FK: {lat: -51.74483954, long: -59.35238956},
    FM: {lat: 7.452468137, long: 153.2394379},
    FO: {lat: 62.05385403, long: -6.880954234},
    FR: {lat: 42.17344011, long: -2.761729445},
    GA: {lat: -0.58660025, long: 11.7886287},
    GB: {lat: 54.12387156, long: -2.865631641},
    GD: {lat: 12.11725044, long: -61.68220189},
    GE: {lat: 42.16855755, long: 43.50780252},
    GG: {lat: 49.46809761, long: -2.572390636},
    GH: {lat: 7.953456435, long: -1.216765658},
    GL: {lat: 74.71051289, long: -41.34191127},
    GM: {lat: 13.44965244, long: -15.39601295},
    GN: {lat: 10.43621593, long: -10.94066612},
    GQ: {lat: 1.705551355, long: 10.34137924},
    GR: {lat: 39.07469623, long: 22.95555794},
    GS: {lat: -54.46488248, long: -36.43318388},
    GT: {lat: 15.69403664, long: -90.36482009},
    GU: {lat: 13.44165626, long: 144.7679102},
    GW: {lat: 12.04744948, long: -14.94972445},
    GY: {lat: 4.79378034, long: -58.98202459},
    HK: {lat: 22.39827737, long: 114.1138045},
    HM: {lat: -53.08724656, long: 73.5205171},
    HN: {lat: 14.82688165, long: -86.6151661},
    HR: {lat: 45.08047631, long: 16.40412899},
    HT: {lat: 18.93502563, long: -72.68527509},
    HU: {lat: 47.16277506, long: 19.39559116},
    ID: {lat: -2.215054563, long: 117.2401137},
    IE: {lat: 53.1754487, long: -8.137935687},
    IL: {lat: 31.46110101, long: 35.00444693},
    IM: {lat: 54.22418911, long: -4.538739523},
    IN: {lat: 22.88578212, long: 79.6119761},
    IO: {lat: -7.330597507, long: 72.44541229},
    IQ: {lat: 33.03970582, long: 43.74353149},
    IR: {lat: 32.57503292, long: 54.27407004},
    IS: {lat: 64.99575386, long: -18.57396167},
    IT: {lat: 42.79662641, long: 12.07001339},
    JE: {lat: 49.21837377, long: -2.126899379},
    JM: {lat: 18.15694878, long: -77.31482593},
    JO: {lat: 31.24579091, long: 36.77136104},
    JP: {lat: 37.59230135, long: 138.0308956},
    KE: {lat: 0.599880215, long: 37.79593973},
    KG: {lat: 41.46221943, long: 74.54165513},
    KH: {lat: 12.72004786, long: 104.9069432},
    KI: {lat: 0.860015032, long: -45.61110513},
    KM: {lat: -11.87783444, long: 43.68253968},
    KN: {lat: 17.2645995, long: -62.68755265},
    KP: {lat: 40.15350311, long: 127.1924797},
    KR: {lat: 36.38523983, long: 127.8391609},
    KW: {lat: 29.33431262, long: 47.58700459},
    KY: {lat: 19.42896497, long: -80.91213321},
    KZ: {lat: 48.15688067, long: 67.29149357},
    LA: {lat: 18.50217433, long: 103.7377241},
    LB: {lat: 33.92306631, long: 35.88016072},
    LC: {lat: 13.89479481, long: -60.96969923},
    LI: {lat: 47.13665835, long: 9.535743118},
    LK: {lat: 7.612665092, long: 80.70108238},
    LR: {lat: 6.452784917, long: -9.322075727},
    LS: {lat: -29.58003188, long: 28.22723131},
    LT: {lat: 55.32610984, long: 23.88719355},
    LU: {lat: 49.76725361, long: 6.071822011},
    LV: {lat: 56.85085163, long: 24.91235983},
    LY: {lat: 27.03094495, long: 18.00866169},
    MA: {lat: 29.83762955, long: -8.456157948},
    MC: {lat: 43.75274627, long: 7.406276769},
    MD: {lat: 47.19498804, long: 28.45673372},
    ME: {lat: 42.78890259, long: 19.23883939},
    MF: {lat: 18.08888611, long: -63.05972851},
    MG: {lat: -19.37189587, long: 46.70473674},
    MH: {lat: 7.003763583, long: 170.3397612},
    MK: {lat: 41.59530893, long: 21.68211346},
    ML: {lat: 17.34581581, long: -3.542690649},
    MM: {lat: 21.18566599, long: 96.48843321},
    MN: {lat: 46.82681544, long: 103.0529976},
    MO: {lat: 22.22311688, long: 113.5093212},
    MP: {lat: 15.82927563, long: 145.6196965},
    MR: {lat: 20.25736706, long: -10.34779815},
    MS: {lat: 16.73941406, long: -62.18518546},
    MT: {lat: 35.92149632, long: 14.40523316},
    MU: {lat: -20.27768704, long: 57.57120551},
    MV: {lat: 3.7287092, long: 73.45713004},
    MW: {lat: -13.21808088, long: 34.28935599},
    MX: {lat: 23.94753724, long: -102.5234517},
    MY: {lat: 3.789868456, long: 109.6976228},
    MZ: {lat: -17.27381643, long: 35.53367543},
    NA: {lat: -22.13032568, long: 17.20963567},
    NC: {lat: -21.29991806, long: 165.6849237},
    NE: {lat: 17.41912493, long: 9.385458815},
    NF: {lat: -29.0514609, long: 167.9492168},
    NG: {lat: 9.594114522, long: 8.089438948},
    NI: {lat: 12.84709429, long: -85.0305297},
    NL: {lat: 52.1007899, long: 5.28144793},
    NO: {lat: 68.75015572, long: 15.34834656},
    NP: {lat: 28.24891365, long: 83.9158264},
    NR: {lat: -0.51912639, long: 166.9325682},
    NU: {lat: -19.04945708, long: -169.8699468},
    NZ: {lat: -41.81113557, long: 171.4849235},
    OM: {lat: 20.60515333, long: 56.09166155},
    PA: {lat: 8.517507975, long: -80.11915156},
    PE: {lat: -9.152803813, long: -74.38242685},
    PF: {lat: -14.72227409, long: -144.9049439},
    PG: {lat: -6.464166461, long: 145.2074475},
    PH: {lat: 11.77536778, long: 122.8839325},
    PK: {lat: 29.9497515, long: 69.33957937},
    PL: {lat: 52.12759564, long: 19.39012835},
    PM: {lat: 46.91918789, long: -56.30319779},
    PN: {lat: -24.36500535, long: -128.317042},
    PR: {lat: 18.22813055, long: -66.47307604},
    PS: {lat: 31.91613893, long: 35.19628705},
    PT: {lat: 39.59550671, long: -8.501043613},
    PW: {lat: 7.287427836, long: 134.4080797},
    PY: {lat: -23.22823913, long: -58.40013703},
    QA: {lat: 25.30601188, long: 51.18479632},
    RO: {lat: 45.85243127, long: 24.97293039},
    RS: {lat: 44.2215032, long: 20.78958334},
    RU: {lat: 61.98052209, long: 96.68656112},
    RW: {lat: -1.990338317, long: 29.91988515},
    SA: {lat: 24.12245841, long: 44.53686271},
    SB: {lat: -8.921780217, long: 159.6328767},
    SC: {lat: -4.660990935, long: 55.47603279},
    SD: {lat: 15.99035669, long: 29.94046812},
    SE: {lat: 62.77966519, long: 16.74558049},
    SG: {lat: 1.358760871, long: 103.8172559},
    SH: {lat: -12.40355951, long: -9.547794159},
    SI: {lat: 46.11554772, long: 14.80444238},
    SK: {lat: 48.70547528, long: 19.47905218},
    SL: {lat: 8.56329593, long: -11.79271247},
    SM: {lat: 43.94186747, long: 12.45922334},
    SN: {lat: 14.36624173, long: -14.4734924},
    SO: {lat: 4.750628761, long: 45.70714487},
    SR: {lat: 4.13055413, long: -55.9123457},
    SS: {lat: 7.308779449, long: 30.24790002},
    ST: {lat: 0.443914449, long: 6.724296579},
    SV: {lat: 13.73943744, long: -88.87164469},
    SX: {lat: 18.05081728, long: -63.05713363},
    SY: {lat: 35.02547389, long: 38.50788204},
    SZ: {lat: -26.55843045, long: 31.4819369},
    TC: {lat: 21.83047572, long: -71.97387881},
    TD: {lat: 15.33333759, long: 18.64492513},
    TF: {lat: -49.24895485, long: 69.22666758},
    TG: {lat: 8.525313561, long: 0.96232845},
    TH: {lat: 15.11815794, long: 101.0028813},
    TJ: {lat: 38.5304539, long: 71.01362631},
    TL: {lat: -8.82889162, long: 125.8443898},
    TM: {lat: 39.11554137, long: 59.37100021},
    TN: {lat: 34.11956246, long: 9.552883589},
    TO: {lat: -20.42843174, long: -174.8098734},
    TR: {lat: 39.0616029, long: 35.16895346},
    TT: {lat: 10.45733408, long: -61.26567923},
    TW: {lat: 23.7539928, long: 120.9542728},
    TZ: {lat: -6.275654083, long: 34.81309981},
    UA: {lat: 48.99656673, long: 31.38326469},
    UG: {lat: 1.274692987, long: 32.36907971},
    US: {lat: 45.6795472, long: -112.4616737},
    UY: {lat: -32.79951534, long: -56.01807053},
    UZ: {lat: 41.75554225, long: 63.14001528},
    VA: {lat: 41.90174985, long: 12.43387177},
    VC: {lat: 13.22472269, long: -61.20129695},
    VE: {lat: 7.124224213, long: -66.18184123},
    VG: {lat: 18.52585755, long: -64.47146992},
    VI: {lat: 17.95500624, long: -64.80301538},
    VN: {lat: 16.6460167, long: 106.299147},
    VU: {lat: -16.22640909, long: 167.6864464},
    WF: {lat: -13.88737039, long: -177.3483483},
    WS: {lat: -13.75324346, long: -172.1648506},
    YE: {lat: 15.90928005, long: 47.58676189},
    ZA: {lat: -29.00034095, long: 25.08390093},
    ZM: {lat: -13.45824152, long: 27.77475946},
    ZW: {lat: -19.00420419, long: 29.8514412}
}

export const languages = [
    {id: '1', name: 'English'},
    {id: '2', name: 'German'},
    {id: '3', name: 'Spanish'},
    {id: '4', name: 'French'},
    {id: '5', name: 'Portugese'},
    {id: '6', name: 'Thai'},
    {id: '7', name: 'Hindi'},
    {id: '8', name: 'Indonesian'},
    {id: '9', name: 'Arabic'},
    {id: '10', name: 'Bulgarian'},
    {id: '11', name: 'Chinese - Simplified'},
    {id: '12', name: 'Chinese - Traditional'},
    {id: '13', name: 'Czech'},
    {id: '14', name: 'Danish'},
    {id: '15', name: 'Dutch'},
    {id: '16', name: 'Estonian'},
    {id: '17', name: 'Finnish'},
    {id: '18', name: 'Greek'},
    {id: '19', name: 'Hebrew'},
    {id: '20', name: 'Hungarian'},
    {id: '21', name: 'Icelandic'},
    {id: '22', name: 'Italian'},
    {id: '23', name: 'Japanese'},
    {id: '24', name: 'Korean'},
    {id: '25', name: 'Latvian'},
    {id: '26', name: 'Lithuanian'},
    {id: '27', name: 'Norwegian'},
    {id: '28', name: 'Polish'},
    {id: '29', name: 'Romanian'},
    {id: '30', name: 'Russian'},
    {id: '31', name: 'Swedish'},
    {id: '32', name: 'Turkish'}
]

export const languagesCodes = [
    {value: 'EN', name: 'English'},
    {value: 'DE', name: 'German'},
    {value: 'ES', name: 'Spanish'},
    {value: 'FR', name: 'French'},
    {value: 'PT', name: 'Portugese'},
    {value: 'AR', name: 'Arabic'},
    {value: 'BG', name: 'Bulgarian'},
    {value: 'CN', name: 'Chinese - Simplified'},
    {value: 'TW', name: 'Chinese - Traditional'},
    {value: 'CS', name: 'Czech'},
    {value: 'DA', name: 'Danish'},
    {value: 'NL', name: 'Dutch'},
    {value: 'ET', name: 'Estonian'},
    {value: 'FA', name: 'Farsi'},
    {value: 'FI', name: 'Finnish'},
    {value: 'EL', name: 'Greek'},
    {value: 'IW', name: 'Hebrew'},
    {value: 'HI', name: 'Hindi'},
    {value: 'HU', name: 'Hungarian'},
    {value: 'IS', name: 'Icelandic'},
    {value: 'ID', name: 'Indonesian'},
    {value: 'IT', name: 'Italian'},
    {value: 'JA', name: 'Japanese'},
    {value: 'KO', name: 'Korean'},
    {value: 'LV', name: 'Latvian'},
    {value: 'LT', name: 'Lithuanian'},
    {value: 'NO', name: 'Norwegian'},
    {value: 'PL', name: 'Polish'},
    {value: 'RO', name: 'Romanian'},
    {value: 'RU', name: 'Russian'},
    {value: 'SV', name: 'Swedish'},
    {value: 'TH', name: 'Thai'},
    {value: 'TK', name: 'Turkish'}
]


export const languagesEngines = [
    {value: 'EN', name: 'www.google.com'},
    {value: 'DE', name: 'www.google.de'},
    {value: 'ES', name: 'www.google.com.mx'},
    {value: 'TH', name: 'www.google.co.th'},
    {value: 'ID', name: 'www.google.co.id'},
    {value: 'HI', name: 'www.google.co.in'},
    {value: 'AR', name: 'www.google.ae'},
    {value: 'PT', name: 'www.google.co.ao'},
    {value: 'ES', name: 'www.google.com.ar'},
    {value: 'DE', name: 'www.google.at'},
    {value: 'FR', name: 'www.google.be'},
    {value: 'FR', name: 'www.google.bf'},
    {value: 'BG', name: 'www.google.bg'},
    {value: 'AR', name: 'www.google.com.bh'},
    {value: 'FR', name: 'www.google.bj'},
    {value: 'ES', name: 'google.com.bo'},
    {value: 'PT', name: 'www.google.com.br'},
    {value: 'RU', name: 'www.google.by'},
    {value: 'FR', name: 'www.google.ch'},
    {value: 'ES', name: 'www.google.cl'},
    {value: 'BG', name: 'www.google.com.hk'},
    {value: 'ES', name: 'www.google.com.co'},
    {value: 'ES', name: 'www.google.co.cr'},
    {value: 'PT', name: 'www.google.cv'},
    {value: 'CS', name: 'www.google.cz'},
    {value: 'DA', name: 'www.google.dk'},
    {value: 'ES', name: 'www.google.com.do'},
    {value: 'AR', name: 'www.google.dz'},
    {value: 'ES', name: 'www.google.com.ec'},
    {value: 'ET', name: 'www.google.ee'},
    {value: 'AR', name: 'www.google.com.eg'},
    {value: 'ES', name: 'www.google.es'},
    {value: 'FI', name: 'www.google.fi'},
    {value: 'FR', name: 'www.google.fr'},
    {value: 'EL', name: 'www.google.gr'},
    {value: 'ES', name: 'www.google.com.gt'},
    {value: 'ES', name: 'www.google.hn'},
    {value: 'HU', name: 'www.google.hu'},
    {value: 'IW', name: 'www.google.co.il'},
    {value: 'IS', name: 'www.google.is'},
    {value: 'IT', name: 'www.google.it'},
    {value: 'AR', name: 'www.google.jo'},
    {value: 'JA', name: 'www.google.co.jp'},
    {value: 'RU', name: 'www.google.kg'},
    {value: 'KO', name: 'www.google.co.kr'},
    {value: 'AR', name: 'www.google.com.kw'},
    {value: 'RU', name: 'www.google.kz'},
    {value: 'AR', name: 'www.google.com.lb'},
    {value: 'LT', name: 'www.google.lt'},
    {value: 'FR', name: 'www.google.lu'},
    {value: 'LV', name: 'www.google.lv'},
    {value: 'FR', name: 'www.google.mg'},
    {value: 'FR', name: 'www.google.ml'},
    {value: 'PT', name: 'www.google.com'},
    {value: 'AR', name: 'www.google.com'},
    {value: 'PT', name: 'www.google.co.mz'},
    {value: 'FR', name: 'www.google.ne'},
    {value: 'ES', name: 'www.google.com.ni'},
    {value: 'NL', name: 'www.google.nl'},
    {value: 'AR', name: 'www.google.com.om'},
    {value: 'ES', name: 'www.google.com.pa'},
    {value: 'ES', name: 'www.google.com.pe'},
    {value: 'PL', name: 'www.google.pl'},
    {value: 'PT', name: 'www.google.pt'},
    {value: 'ES', name: 'www.google.com.py'},
    {value: 'AR', name: 'www.google.com.qa'},
    {value: 'RO', name: 'www.google.ro'},
    {value: 'RU', name: 'www.google.ru'},
    {value: 'AR', name: 'www.google.com.sa'},
    {value: 'FR', name: 'www.google.sc'},
    {value: 'SV', name: 'www.google.se'},
    {value: 'FR', name: 'www.google.sn'},
    {value: 'ES', name: 'www.google.com.sv'},
    {value: 'AR', name: 'www.google.td'},
    {value: 'AR', name: 'www.google.tn'},
    {value: 'ES', name: 'www.google.com.uy'},
    {value: 'ES', name: 'www.google.co.ve'},
    {value: 'AR', name: 'www.google.com'},
    {value: 'NO', name: 'www.google.no'},
    {value: 'FR', name: 'www.google.ci'},
    {value: 'AR', name: 'www.google.iq'},
    {value: 'FR', name: 'www.google.cd'}
]